import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/legacy/build/pdf.worker.mjs",
  import.meta.url,
).toString();

// worker と cMap の設定をそろえるため、PDF の読み込みはここを経由する
export const loadPdfDocument = (url: string) =>
  pdfjsLib.getDocument({
    url,
    cMapUrl: "/cmaps/",
    cMapPacked: true,
  });
